import React, { useState } from 'react';
import { ArrowLeft, Play, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/gallery.css';

// Gallery media - imported from carousel + additional content
const galleryMedia = [
  { type: 'video', src: '/images/hero/bungee_1_family.mp4', category: 'bungee', title: 'Family Flight' },
  { type: 'image', src: '/images/hero/aerial_hoop_maggie.jpg', category: 'aerial', title: 'Aerial Hoop' },
  { type: 'image', src: '/images/hero/bungee_betsy_katie.jpg', category: 'bungee', title: 'Flying Together' },
  { type: 'image', src: '/images/hero/aerial_1_silks.png', category: 'aerial', title: 'Silks' },
  { type: 'image', src: '/images/hero/bungee_cal_star.jpg', category: 'bungee', title: 'Star Pose' },
  { type: 'image', src: '/images/hero/consulting_1_sunrise.png', category: 'energy', title: 'Sunrise Session' },
  { type: 'image', src: '/images/hero/aerial_2_trapeze.jpg', category: 'aerial', title: 'Trapeze' },
  { type: 'image', src: '/images/hero/bungee_play.jpg', category: 'bungee', title: 'Pure Play' },
  { type: 'image', src: '/images/hero/bungee_swan_prep.jpg', category: 'bungee', title: 'Swan Prep' },
  { type: 'image', src: '/images/hero/bungee_3_squatting.jpeg', category: 'bungee', title: 'Power Squat' },
  { type: 'image', src: '/images/hero/aerial_hoop_sara.jpg', category: 'aerial', title: 'Hoop Flow' },
  { type: 'image', src: '/images/hero/bungee_high5.jpg', category: 'bungee', title: 'High Five' },
  { type: 'image', src: '/images/hero/aerial_3_lyra_fans.png', category: 'aerial', title: 'Lyra Fans' },
  { type: 'image', src: '/images/hero/bungee_trio.jpg', category: 'bungee', title: 'Trio' },
  { type: 'image', src: '/images/hero/bungee_6_heart.jpeg', category: 'bungee', title: 'Heart Formation' },
  { type: 'image', src: '/images/hero/aerial_4_birthday.jpg', category: 'aerial', title: 'Birthday Party' },
  { type: 'image', src: '/images/hero/bungee_anytime.jpg', category: 'bungee', title: 'Anytime Fitness' },
  { type: 'image', src: '/images/hero/bungee_7_group.png', category: 'bungee', title: 'Group Energy' },
  // New additions
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/wjalw4hs_AFAshlee%26Cal.JPG', category: 'bungee', title: 'Ashlee & Cal at Anytime Fitness' },
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/onhah514_CalCrystalFunny.JPG', category: 'bungee', title: 'Cal & Crystal Having Fun' },
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/791be4bb_Elf%20at%20the%20Studio.JPG', category: 'aerial', title: 'Holiday Magic at the Studio' },
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/062hb69n_WillsWonderwoman.JPG', category: 'aerial', title: 'Little Wonder Woman' },
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/b2zu8nbd_Bungee_Cal%26JesseSTAR_SmallGroupClasses.JPEG', category: 'bungee', title: 'Cal & Jesse Star Pose' },
  { type: 'image', src: 'https://customer-assets.emergentagent.com/job_57c0eb9c-3961-4c7d-95b0-bd77dac9c429/artifacts/foikc3lt_DSC_1607.jpg', category: 'bungee', title: 'Bungee Training Session' },
];

const GalleryPage = () => {
  const [filter, setFilter] = useState('all');
  const [lightboxItem, setLightboxItem] = useState(null);

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'bungee', label: 'Bungee' },
    { id: 'aerial', label: 'Aerial Kids' },
    { id: 'energy', label: 'Energy' },
  ];

  const filteredMedia = filter === 'all' 
    ? galleryMedia 
    : galleryMedia.filter(item => item.category === filter);

  const openLightbox = (item) => {
    setLightboxItem(item);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxItem(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="gallery-page">
      {/* Hero Header */}
      <section className="gallery-hero">
        <div className="gallery-hero-content">
          <h1 className="gallery-title">Gallery</h1>
          <p className="gallery-subtitle">
            Moments of flight, joy, and transformation.
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <div className="gallery-filters">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={`filter-btn ${filter === cat.id ? 'active' : ''}`}
            onClick={() => setFilter(cat.id)}
            data-testid={`filter-${cat.id}`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Masonry Gallery Grid */}
      <section className="gallery-grid-container">
        <div className="gallery-grid" data-testid="gallery-grid">
          {filteredMedia.map((item, index) => (
            <div 
              key={index}
              className={`gallery-item ${item.type}`}
              onClick={() => openLightbox(item)}
              data-testid={`gallery-item-${index}`}
            >
              {item.type === 'video' ? (
                <div className="gallery-video-thumb">
                  <video src={item.src} muted preload="metadata" />
                  <div className="video-play-icon">
                    <Play size={40} />
                  </div>
                </div>
              ) : (
                <img src={item.src} alt={item.title} loading="lazy" />
              )}
              <div className="gallery-item-overlay">
                <span className="gallery-item-title">{item.title}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxItem && (
        <div className="lightbox" onClick={closeLightbox} data-testid="lightbox">
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={32} />
          </button>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            {lightboxItem.type === 'video' ? (
              <video 
                src={lightboxItem.src} 
                controls 
                autoPlay 
                className="lightbox-video"
              />
            ) : (
              <img 
                src={lightboxItem.src} 
                alt={lightboxItem.title}
                className="lightbox-image"
              />
            )}
            <p className="lightbox-title">{lightboxItem.title}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
